import { AuthenticationContext } from "react-adal/lib/react-adal";

let tenant = "d3150922-5d82-4a69-822b-fd02555e4339";
let clientId = "df696bb5-bc4d-4240-8641-44d3d5fb88e0";
let api= "https://grafokett.onmicrosoft.com/df696bb5-bc4d-4240-8641-44d3d5fb88e0";

if (window.location.hostname.includes('test') || window.location.hostname.includes('prod')){
  tenant= "d3150922-5d82-4a69-822b-fd02555e4339";
  clientId= "df696bb5-bc4d-4240-8641-44d3d5fb88e0";
  api= "https://grafokett.onmicrosoft.com/df696bb5-bc4d-4240-8641-44d3d5fb88e0";
}

const adalConfig = {
  tenant,
  clientId,
  endpoints: {
    api
  },
  cacheLocation: 'sessionStorage'
};

export const authContext = new AuthenticationContext(adalConfig);

// Helper to get token - tries cache first
const getTokenSync = () => {
    // In react-adal, when using endpoints, we need to use the endpoint key (the string key, not the value)
    // The endpoint key is 'api' (the property name in endpoints object)
    const endpointKey = 'api';
    
    // Try multiple ways to get the token
    let token = authContext.getCachedToken(api); // Try with API resource value
    if (!token) {
        token = authContext.getCachedToken(endpointKey); // Try with endpoint key
    }
    if (!token) {
        token = authContext.getCachedToken(clientId); // Fallback to clientId
    }
    
    return token;
};

// Use 'api' instead of 'clientId' to get token for the API resource (not the client app)
export const getToken = () => {
    return getTokenSync();
};

// Decode JWT token to extract claims
const decodeJWT = (token) => {
    try {
        if (!token) return null;
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Failed to decode JWT:', error);
        return null;
    }
};

// Get user email from JWT token
export const getUserEmailFromToken = () => {
    const token = getToken();
    if (!token) return null;
    const decoded = decodeJWT(token);
    return decoded?.email || null;
};